<template>

  <div class="modal" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content" style="width:880px">
        <div class="modal-header">
          <h5 class="modal-title text-center"> <b> Certificado Autogenerado </b> </h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"> <span aria-hidden="true">&times;</span> </button>
        </div>
        <div class="modal-body text-left">
          <p v-show="cargando" class="text-center text-primary">Cargando datos...</p>
          <canvas id="myCanvas2" width="842" height="597" style="border:1px solid #55d3d3d3;">
          </canvas>
          <p v-show="cargando" class="text-center text-primary">Cargando datos...</p>

          <button class="btn btn-sm" @click="guardar()"> Guardar </button>
          <a href="" id="link"></a>
          <div id="qrcode"></div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  props:{ model:{type:Object,required:true} },
  data(){
    return{
      cargando: false,
      image: null,
      qrLeft: null,
      qrRight: null,
    }
  },
  watch:{
    'model.inscripcion':function(){
      //window.console.log( "CARGANDO IMAGENNNNNNNNN",a );
      this.cargarQRleft();
      this.cargarQRRight();
      var vue = this;
      this.cargando = true;
      setTimeout( function(){
        vue.cargarCanvas()
        vue.cargando = false;
      },2000)
    }
  },
  methods:{
    parseEst(){
      if( !this.model.inscripcion ) return "NUL"
      var es = this.model.inscripcion.estudiante;
      if( !es ) return "NULO"
      var am = es.seg_apellido?es.seg_apellido:"";
      return es.nombres+" "+es.pri_apellido+" "+am;
    },
    parseCargaHoraria(){
      if( this.model.inscripcion == null ) return "1";
      if( this.model.inscripcion.programa == null ) return "2";
      if( this.model.inscripcion.programa.postgrado == null ) return "3";
      var post = this.model.inscripcion.programa.postgrado;
      return post.carga_horaria;
    },
    parseSedeCiudad(){
      /*if( this.model.inscripcion == null ) return "1";
      if( this.model.inscripcion.programa == null ) return "2";
      if( this.model.inscripcion.programa.sede == null ) return "3";
      var sede = this.model.inscripcion.programa.sede.ciudad;
      return sede.nombre;*/
      window.console.log("-----------------------",this.$store.state.CARGO.sede.nombre)
      return this.$store.state.CARGO.sede.nombre.substring(5);
    },
    parseProgram(){
      if( this.model.inscripcion == null ) return "1";
      if( this.model.inscripcion.programa == null ) return "2";
      if( this.model.inscripcion.programa.postgrado == null ) return "3";
      var post = this.model.inscripcion.programa.postgrado;
      return (post.categoria.nombre+" "+post.nombre).toUpperCase();
    },
    parseProgramQr(){
      /*if( this.model.inscripcion == null ) return "1";
      if( this.model.inscripcion.programa == null ) return "2";
      if( this.model.inscripcion.programa.postgrado == null ) return "3";
      if( this.model.inscripcion.programa.postgrado.categoria == null ) return "4";
      var pro = this.model.inscripcion.programa;*/
      var post = "";
      var str = "Webinar Gratuito: \n"+(post).toUpperCase();
      //str += "Sede: "+pro.sede.nombre+".\nRealizado del "+this.parseFecha(pro.fecha_inicio)+" AL "+this.parseFecha(pro.fecha_fin);
      str += "\n\nGracias por elegirnos."
      str += "\n"+process.env.VUE_APP_NAME
      return str;
    },
    parseEstudiante(){
      if( this.model.inscripcion == null ) return "1";
      if( this.model.inscripcion.estudiante == null ) return "2";
      var es = this.model.inscripcion.estudiante;
      if( es.seg_apellido == null ) es.seg_apellido = ""
      var str = "Estudiante: "+es.nombres+" "+es.pri_apellido+" "+es.seg_apellido+"\n"
      str += "Documento: --\n"
      str += "Correo: "+es.email+"\n"
      str += "Telefono: "+es.telefono1+"\n"
      str += "Usuario Moodle: --\n"
      str += "Clave Moodle: --\n"
      return str;
    },
    parseFecha( f ){
      if( f == null ) return "";
      var fs = f.split('-');
      return fs[2]+"/"+fs[1]+"/"+fs[0];
    },
    parseMes( m ){
      if( m == 0 ) return "Enero"
      else if( m == 1 ) return "Febrero"
      else if( m == 2 ) return "Marzo"
      else if( m == 3 ) return "Abril"
      else if( m == 4 ) return "Mayo"
      else if( m == 5 ) return "Junio"
      else if( m == 6 ) return "Julio"
      else if( m == 7 ) return "Agosto"
      else if( m == 8 ) return "Septiembre"
      else if( m == 9 ) return "Octubre"
      else if( m == 10 ) return "Noviembre"
      else if( m == 11 ) return "Diciembre"
    },

    cargarCanvas(){
      var estudiante = this.parseEst();
      var c = document.getElementById("myCanvas2");
      var ctx = c.getContext("2d");
      ctx.drawImage(this.image, 0, 0, 842, 597);

      var date = new Date();
      var dia = date.getDate();
      var year = date.getFullYear();
      var mes = this.parseMes( date.getMonth() )

      ctx.drawImage(this.qrLeft, 150, 130, 80, 80);
      ctx.drawImage(this.qrRight, 610, 130, 80, 80);

      ctx.font = "33px Arial";
      ctx.textAlign = "center";
      ctx.fillText(""+estudiante, (c.width/2)+30, 345);

      /*ctx.font = "25px Arial";
      ctx.textAlign = "center";
      ctx.fillText(""+estudiante, c.width/2, 355);*/
      ctx.font = "20px Courier";
      /*var pp = this.parseProgram();
      if( pp.length > 50 ){
        pp = this.wordWrapToStringList( pp,50 );
        window.console.log( pp )
        var tt=415;
        pp.forEach(function( e ){
          ctx.fillText(""+e, c.width/2, tt);
          tt +=18;
        });
      }else{
        ctx.fillText(""+pp, c.width/2, 415);
      }*/
      ctx.font = "16px Courier";
      ctx.fillText(""+this.parseCargaHoraria(), 405, 450);
      ctx.fillText(""+this.parseSedeCiudad(), 335, 475);
      ctx.fillText(""+dia, 550, 475);
      ctx.fillText(""+mes, 345, 495);
      ctx.fillText(""+year, 550, 495);
    },
    getDatos(){
      var xins = sessionStorage.xxinscripcion;
      this.model.inscripcion =JSON.parse( xins );
      window.console.log( window.stringifyObject(this.model.inscripcion) )
      this.cargarCanvas();
    },
    cargarQRleft(){
      window.console.log( window.stringifyObject(this.model.inscripcion) )
      if( this.qrLeft ) return;
      var p = this.parseProgramQr();

      var qr = new window.VanillaQR({
        url: p,
        width: 400,
        height: 400,
        colorLight: "#FFFFFF",
        colorDark: "#000000",
        toTable: false,
        ecclevel: 1,
        noBorder: true,
        borderSize: 1,
      });

      this.qrLeft = qr.toImage("png");
    },
    cargarQRRight(){
      //if( this.qrRight ) return;
      var p = this.parseEstudiante();

      var qr = new window.VanillaQR({
        url: p,
        width: 400,
        height: 400,
        colorLight: "#FFFFFF",
        colorDark: "#000000",
        toTable: false,
        ecclevel: 1,
        noBorder: true,
        borderSize: 1,
      });

      this.qrRight = qr.toImage("png");
    },
    guardar(){
      var canvas = document.getElementById("myCanvas2");
      var nombre = this.parseEst();
      var link = document.getElementById('link');
      link.setAttribute('download', nombre+'.png');
      link.setAttribute('href', canvas.toDataURL("image/png").replace("image/png", "image/octet-stream"));
      link.click();
    }
  },
  mounted(){
    this.image = new Image();
    this.image.src = "img/webinarr.png";
    
  }
}
</script>